// extracted by mini-css-extract-plugin
export default {"login":"Login_login__hpWy4","applications-buttons":"Login_applications-buttons__Ap5Jf"};